import { colors } from "../config/colors.mjs";
const radiusTokens = {
    "skeleton.bar.radius": 24,
    "skeleton.square.radius": 12
  },
  sizeTokens = {
    "skeleton.bar.height.big": 16,
    "skeleton.bar.height.small": 8,
    "skeleton.square.size.big": 64,
    "skeleton.square.size.small": 40
  },
  colorTokens = {
    "skeleton.gradient.start": colors["grey.300"],
    "skeleton.gradient.stop": colors["grey.100"]
  };
export { colorTokens, radiusTokens, sizeTokens };
//# sourceMappingURL=Skeleton.tokens.mjs.map
